export default __webpack_public_path__ + "static/media/ke.bdd8fd09.svg";